import { useObservationDateQueryParam } from '../../../hooks';
import {
  MapEntityEditorViewState,
  resetMapState,
  setMapStopViewStateAction,
  setSelectedStopIdAction,
  useAppDispatch,
} from '../../../redux';
import { useNavigateToMap } from '../../common/Utils';
import { useUpdateStopPriorityFilterIfNeeded } from '../../Map/Stops/utils';
import { useEnsureStopVehicleModeVisible } from '../../Map/Utils/useEnsureStopVehicleModeVisible';
import { LocatableStop } from '../Types';

export function useShowStopOnMap() {
  const dispatch = useAppDispatch();

  // Get existing observationDate or default, but don't touch the URL
  const { observationDate: currentObservationDate } =
    useObservationDateQueryParam({
      initialize: false,
    });
  const navigateToMap = useNavigateToMap();
  const ensureVehicleModeVisible = useEnsureStopVehicleModeVisible();
  const updatePriorityFilterIfNeeded = useUpdateStopPriorityFilterIfNeeded();

  return (
    { netexId, location, priority, transportMode }: LocatableStop,
    observeOnDate: Temporal.PlainDate | null = null,
  ) => {
    dispatch(resetMapState()).then(() => {
      if (netexId) {
        dispatch(setSelectedStopIdAction(netexId));
        dispatch(setMapStopViewStateAction(MapEntityEditorViewState.POPUP));
      }

      if (priority !== undefined) {
        updatePriorityFilterIfNeeded(priority);
      }
      ensureVehicleModeVisible(transportMode);

      navigateToMap({
        viewPort: {
          latitude: location.latitude,
          longitude: location.longitude,
          zoom: 15,
        },
        filters: {
          observationDate: observeOnDate ?? currentObservationDate,
        },
      });
    });
  };
}
